import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MobileAppContextService } from "../mobile-app-context.service";
import { mobilePath } from "../mobile-routes.constants";

@Component({
  selector: "mobile-header",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./mobile-header.component.html",
  styleUrl: "./mobile-header.component.scss",
})
export class MobileHeaderComponent {
  @Input() titleKey = "app.launcher.title";
  /** When set, shown instead of translated titleKey (e.g. active application name). */
  @Input() titleText: string | null = null;
  @Input() showLogout = false;
  @Input() logoSrc: string | null = "assets/kiraah/logo-kiraah.svg";
  @Input() showBackToApps = false;
  @Input() showBurger = false;
  @Output() readonly logout = new EventEmitter<void>();
  @Output() readonly burgerToggle = new EventEmitter<void>();

  private readonly router = inject(Router);
  private readonly appContext = inject(MobileAppContextService);

  async onBackToApps(): Promise<void> {
    await this.appContext.clearActiveApplication();
    await this.router.navigateByUrl(mobilePath("launcher"));
  }
}
